module.exports = __webpack_public_path__ + "static/media/uprightHard.582b0d6b.svg";